<template>
    <transition name="fade" mode="out-in">
        <div v-if="resource.ready && selects.ready">
            <div class="card mb-3">
                <div class="card-title" v-once>
                    <span>Замена товара – #{{ entry.id }} ({{ entry.product.name }})</span>
                </div>

                <form class="spaced-y-4" @submit.prevent="submit">
                    <div class="flex -mx-2">
                        <select-field
                            :filter-by="productsFilterBy"
                            class="w-1/2 px-2"
                            title="Новый товар"
                            label="name"
                            valueName="id"
                            :options="products"
                            v-model="replacement.product_id"
                            :errors="errors.product_id"
                            :clearable="false"
                            required
                        />

                        <text-field
                            type="number"
                            class="w-1/2 px-2"
                            title="Доплата"
                            v-model="replacement.amount"
                            :errors="errors.amount"
                            required
                        />
                    </div>

                    <hr class="mb-3" />

                    <button :disabled="saving" class="btn btn-primary">Отправить</button>
                </form>
            </div>
        </div>
    </transition>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";
import qs from "qs";

export default {
    extends: ResourceForm,

    data() {
        return {
            resource: {
                name: "admin.billing.rentals",
                endpoint: "admin/billing/rentals"
            },

            selects: {
                ready: false,
                products: []
            },

            replacement: {
                product_id: null,
                amount: null
            }
        };
    },

    computed: {
        products() {
            return this.selects.products.filter(
                product => product.id != this.entry.product_id
            );
        }
    },

    methods: {
        productsFilterBy(model, match, query) {
            return (
                match.indexOf(query) !== -1 ||
                (model.unique_id && model.unique_id.indexOf(query) !== -1)
            );
        },

        onFetch() {
            this.entry.product_id = null;
        },

        async fetchSelects() {
            await axios
                .get("/admin/products/all", {
                    params: {
                        filters: {
                            rentable: 1
                        }
                    },
                    paramsSerializer: params => {
                        return qs.stringify(params);
                    }
                })
                .then(response => {
                    this.selects.products = response.data.data;
                });

            this.selects.ready = true;
        },

        submit() {
            axios
                .post(
                    `/admin/billing/rentals/${this.entry.id}/replace`,
                    this.replacement
                )
                .then(response => {
                    this.$message.success("Товар заменен");

                    this.$router.push({
                        name: "admin.billing.rentals.edit",
                        params: {
                            id: this.entry.id
                        }
                    });
                });
        }
    },

    mounted() {
        this.fetchSelects();
    }
};
</script>